package one.healthium.base.di

import one.healthium.base.browser.Browser
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

actual fun baseUtilsPlatformModule() = module {
    singleOf(::Browser)
}